import {lighten} from 'polished';
import styled from 'styled-components';

import {Icon} from 'components/ui-kit/Icon';
import {breakpoint, colors} from 'theme';

import {ProductSingleItemQuantity} from '../OrdersCreate/styled';

export const HeaderControls = styled.div`
    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: 20px;
    }
`;

export const ProductGroupIcon = styled(Icon)`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    background-color: ${lighten(0.35, colors.brandPrimary)};
`;

export const Quantity = styled(ProductSingleItemQuantity)``;
